import { defaultBorrowerLegalName } from '../../../../../../../components/loan_application/form_models/constants';
import loanFormModel from '../../../../../../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { RulesetResult } from '../../business/rules';
import { Validation } from '../../../../../../../validations/Validation';
import { SingleOrMultipleUsersRuleset } from '../../business/ruleset';
import * as Yup from 'yup';

const {
  formField: { systemPowerSingleOrMultipleUsers },
} = loanFormModel;

// SUNENG-2991: [BAv5.4] Update 'PPA-PWR_USER_NO-SEL' rule
export class SingleOrMultipleUsersValidation implements ValidationSchema {
  public name: string = systemPowerSingleOrMultipleUsers.name;
  public label: string = systemPowerSingleOrMultipleUsers.getLabel(
    defaultBorrowerLegalName
  );
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = SingleOrMultipleUsersRuleset;

  public when(schema: Yup.StringSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    if (required) return schema.required('This field is required');

    return schema;
  }
}
export default new Validation(new SingleOrMultipleUsersValidation());
